import './search-box.styles.css';
import { IoSearch } from "react-icons/io5";
import { useState, useEffect, useRef } from 'react';
import translations from '../../translate';


const SearchBox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const searchBoxRef = useRef(null);

  // وقتی خارج از search-box کلیک شد
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchBoxRef.current && !searchBoxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  

  return (
    <form className="search-box" ref={searchBoxRef}>
      <input
        id="search-input"
        type="text"
        className={`search-input ${isOpen ? 'open' : ''}`}
        onFocus={() => setIsOpen(true)}
      />
      <label htmlFor="search-input" className="search-input-label" onClick={() => setIsOpen(true)}>
        {isOpen ? '' : 'Search'}
      </label>
      <button type="submit" className="search-button">
        <IoSearch />
      </button>
    </form>
  );
};

export default SearchBox;
